import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';

import type {
    TIsoCountry
} from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class IsoCountriesService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    // public getObservable(): Observable<TIsoCountry[]> {
    //     const collection = this.firestorePathsService.getIsoCountriesPath();
    //     const observable = collection.valueChanges();
    //     return observable;
    // }

    public async getByFieldValue(fieldName: string, fieldValue: string): Promise<TIsoCountry[]> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TIsoCountry[]>;
    }

    public async getByUid(uid: string): Promise<TIsoCountry> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TIsoCountry>;
    }

    public async getAll(): Promise<TIsoCountry[]> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        const items = await this.firestoreService.getAll(path) as Promise<TIsoCountry[]>;
        return items;
    }

    public async add(country: TIsoCountry): Promise<TIsoCountry> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        return this.firestoreService.add(path, country) as Promise<TIsoCountry>;
    }

    public async set(country: TIsoCountry): Promise<TIsoCountry> {
        // country.uid = country.uid;
        const path = this.firestorePathsService.getIsoCountriesPath();
        await this.firestoreService.set(path, country);
        return country;
    }

    public async update(country: TIsoCountry): Promise<TIsoCountry> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        return this.firestoreService.update(path, country) as Promise<TIsoCountry>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getIsoCountriesPath();
        return this.firestoreService.delete(path, uid);
    }

    public async getByCountryName(countryName: string): Promise<TIsoCountry> {
        const countries = await this.getByFieldValue('countryName', countryName);
        return countries[0];
    }

    // public getcountry(accountNumber: string, countryUid: string): Promise<TCountry> {
    //     const collection = this.firestorePathsService.getcountryColByAccountNumber(accountNumber);
    //     return this.getByUid(countryUid);
    // }

    public sortCountries(countries: TIsoCountry[]): TIsoCountry[] {
        const sortedCountries = countries.sort((a, b) => {
            // return a.localCompare(b);    // localCompare doesn't exist, so do the compare ourselves
            if (a.countryName < b.countryName) {
                return -1;
            } else if (a.countryName > b.countryName) {
                return 1;
            } else {
                return 0;
            }
        });

        return sortedCountries;
    }
}
